var YepNopeMessagePopup = require("app/AppLayout/YepNopeMessagePopup"),
    config              = require("app/config"),
    frameThrottle       = require("enyo-perf/utils").frameThrottle,
    get                 = require("object-path").get,
    icons               = require("app/theme/icons"),
    kind                = require("enyo/kind"),
    quickMacroize       = require("enyo/macroize").quickMacroize;

module.exports = kind(/** @lends  app.Auth.ContinueSignUpPopup.prototype */ {

    /**
     * @private
     */
    name: "app.Auth.ContinueSignUpPopup",

    /**
     * @private
     */
    kind: YepNopeMessagePopup,

    /**
     * @private
     */
    classes: "app-auth-continue-sign-up-popup",

    /**
     * No close button for this one.
     *
     * @public
     */
    showCloseButton: false,

    /**
     * @private
     */
    handlers: {
        onMessageYepButtonTap:  "onMessageYepButtonTap",
        onMessageNopeButtonTap: "onMessageNopeButtonTap"
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.$.message.$.yepButton.set("icon", icons["app.Auth.ContinueSignUpPopup.yepButton"]);
            this.$.message.$.nopeButton.set("icon", icons["app.Auth.ContinueSignUpPopup.nopeButton"]);
        };
    }),

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            $yepButton  = this.$.message.$.yepButton,
            $nopeButton = this.$.message.$.nopeButton;

        this.$.message.$.title.set("content", i18nService.getString("app.Auth.ContinueSignUpPopup.title"));
        this.$.message.$.body.set("content", i18nService.getString("app.Auth.ContinueSignUpPopup.body"));
        $yepButton.set("caption", i18nService.getString("app.Auth.ContinueSignUpPopup.ContinueButton.caption"));
        $yepButton.set("tooltip", i18nService.getString("app.Auth.ContinueSignUpPopup.ContinueButton.tooltip"));
        $nopeButton.set("caption", i18nService.getString("app.Auth.ContinueSignUpPopup.CancelButton.caption"));
        $nopeButton.set("tooltip", i18nService.getString("app.Auth.ContinueSignUpPopup.CancelButton.tooltip"));
    },

    /**
     * Send user back to sign-up url.
     *
     * @private
     */
    onMessageYepButtonTap: function() {
        var i18nService = this.app.$.i18nService,
            language    = i18nService.get("language"),
            signUpUrl   = get(config, "signUpUrl." + language, null);

        if (signUpUrl) {
            window.location = signUpUrl;
        }
    },

    /**
     * @public
     */
    onMessageNopeButtonTap: function() {
        var i18nService = this.app.$.i18nService;

        this.app.$.router.navigate(quickMacroize("/{$language}/logout", {
            language: i18nService.get("language")
        }));
        this.close();
    }

});
